import styled from "styled-components";
import media from "../../static/style/media";

export const Container = styled.div`
  max-width: 1300px;
  margin: 0 auto;
`;

export const MapContainer = styled.div``;

export const InfoBoxContainer = styled.div`
  background-color: white;
  width: 100px;
  height: 100px;
`;

export const ContentContainer = styled.div`
  height: 500px;
  ${'' /* display: grid; */}
  grid-template-columns: 1fr 100fr;
  ${media.small`
    display: block;
  `}
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;

  font-weight: bold;
  background: #d8d8d8;
`;
